module.exports = __webpack_public_path__ + "static/srinidhi-4bc3f41087d54815932ee80424b12bd7.jpg";